import { useTranslation } from 'react-i18next';

function Experience() {
    const { t } = useTranslation();
    const experienceItems = Array.isArray(t('experience.items', { returnObjects: true })) 
        ? t('experience.items', { returnObjects: true }) 
        : [];

    return (
        <section className="relative py-20 md:py-52 px-4 md:px-8 overflow-hidden">
            {/* Blurred background elements */}
            <div className="absolute top-1/4 -left-20 w-80 h-80 bg-accent/20 dark:bg-primary/40 rounded-full filter blur-3xl opacity-70 dark:opacity-30 animate-blob"></div>
            <div className="absolute bottom-1/4 -right-20 w-80 h-80 bg-secondary/20 dark:bg-secondary/40 rounded-full filter blur-3xl opacity-70 dark:opacity-30 animate-blob animation-delay-2000"></div>
            <div className="absolute top-1/2 left-1/3 w-80 h-80 bg-primary/20 dark:bg-accent/40 rounded-full filter blur-3xl opacity-70 dark:opacity-30 animate-blob animation-delay-4000"></div>

            <div className='container mx-auto max-w-6xl relative z-10'>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-12 text-center text-primary">
                    {t('experience.title')}
                </h2>

                <div className="relative">
                    {/* Timeline */}
                    <div className="absolute top-0 h-full w-0.5 bg-primary/20 left-[11px] md:left-1/2 md:-translate-x-1/2" aria-hidden="true"></div>

                    <div className="space-y-12">
                        {experienceItems.map((item, index) => {
                            const isOdd = index % 2 !== 0;

                            const DateComponent = (
                                <div className={`md:sticky top-24 ${isOdd ? 'md:text-left' : 'md:text-right'}`}>
                                    <span className="inline-block px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium backdrop-blur-sm">
                                        {item.date}
                                    </span>
                                </div>
                            );

                            const ContentComponent = (
                                <div className="bg-base-100/80 dark:bg-base-100/90 p-6 rounded-xl shadow-sm border border-base-300/50 hover:border-primary/30 transition-all duration-300 group-hover:shadow-md backdrop-blur-sm">
                                    <h3 className="text-xl md:text-2xl font-bold mb-2 text-primary">
                                        {item.role}
                                    </h3>
                                    <div className="prose prose-sm md:prose-base text-base-content">
                                        <ul className="list-disc list-outside space-y-2 ml-4">
                                            {item.description.map((desc, i) => (
                                                <li key={i}>{desc}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            );

                            return (
                                <div key={index} className="relative group">
                                    <div className="absolute top-1 left-[4px] md:left-1/2 md:-translate-x-1/2 w-4 h-4 rounded-full bg-primary ring-4 ring-base-100/80 transition-transform duration-300 group-hover:scale-125 z-10"></div>
                                    
                                    <div className={`pl-10 md:pl-0 md:grid md:grid-cols-2 md:gap-x-12`}>
                                        {isOdd ? (
                                            <>
                                                <div className="md:order-2">{DateComponent}</div>
                                                <div className="mt-4 md:mt-0 md:order-1 md:text-right">{ContentComponent}</div>
                                            </>
                                        ) : (
                                            <>
                                                <div>{DateComponent}</div>
                                                <div className="mt-4 md:mt-0">{ContentComponent}</div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Experience;